import React, { FC, PropsWithChildren } from 'react';
import { PropsWithClassProps, DateTime } from '@vgn-medien-holding/vgn-react-components';
import { AuthorLine } from '@components/atoms/AuthorLine/AuthorLine';
import { User } from '@lib/graphql/generated';

export interface TextCardProps
  extends PropsWithClassProps<'text' | 'authorLine' | 'date' | 'names'>,
    PropsWithChildren {
  text: string;
  authors: User[];
  date: Date;
}

export const TextCard: FC<TextCardProps> = ({ children, classProps, text, authors, date }) => {
  return (
    <div className={classProps?.root}>
      <p className={classProps?.text}>{text}</p>
      <span>
        {authors?.length > 0 && <AuthorLine classProps={classProps} authors={authors} />}
        <p>
          <DateTime classProps={classProps} date={date} formatOptions={{ dateStyle: 'short' }} />
        </p>
      </span>
      {children}
    </div>
  );
};
